export { default as Documentos } from "./Documentos"
export {
  default as RelatorioDeclaracaoDoPrepostoForm
} from "./RelatorioDeclaracaoDoPrepostoForm"
export {
  default as RelatorioAtestoDeServicoForm
} from "./RelatorioAtestoDeServicoForm"
export {
  default as RelatorioTermoDeApostilamentoForm
} from "./RelatorioTermoDeApostilamentoForm"
export {
  default as RelatorioDeAtividadesRealizadasForm
} from "./RelatorioDeAtividadesRealizadasForm"
export {
  default as RelatorioAtestadoDeCapacidadeTecnicaForm
} from "./RelatorioAtestadoDeCapacidadeTecnicaForm"



// WEBPACK FOOTER //
// ./src/views/documentos/index.js